<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <v-card >
                <h1 class="formTitle">Loan Application Form</h1>
                <v-card-text>
                   <application-form-stepper/>
                </v-card-text>
            </v-card>
        </base-header>
    </div>
</template>

<script>
import ApplicationFormStepper from '@/components/ApplicationForm/ApplicationFormStepper';
    export default {
        name: "LoanApplicationForm",
        components: {
            ApplicationFormStepper
    },
    data (){
        return {

        }
    },
    created(){
        this.authorizedUser(this.authorizeMemberOnly);
    }
    }
</script>

<style scoped>
.formBorder{
    font-size: .875rem;
    display: block;
    margin: 1rem 0;
    padding: .75rem;
    color: #393f49;
    border-radius: .25rem;
    background-color: #fff;
    box-shadow: rgba(0,0,0,.1) 0 0 0 1px,rgba(0,0,0,.1) 0 4px 16px;
}
    .formTitle{
        font-family: 'Dancing Script', cursive;
        text-align: center;
        padding-top: 20px;
        font-size: 40px;
    }
    .applyButton{
        margin-left: 45%;
    }
@import url('https://fonts.googleapis.com/css?family=Dancing+Script|Satisfy&display=swap');

</style>
